import { ExamType, RegistrationType } from '@report/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsIsoDateTime,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export function useExamEventOverviewReportSearchParams() {
  const [
    {
      examCenter,
      province,
      startDate,
      endDate,
      registrationType,
      examType,
      sortBy,
      sortOrder,
      page,
      pageSize,
    },
    setQueryParams,
  ] = useQueryStates({
    examCenter: parseAsArrayOf(parseAsString).withDefault([]),
    province: parseAsArrayOf(parseAsString).withDefault([]),
    examType: parseAsArrayOf(parseAsStringEnum<ExamType>(Object.values(ExamType))).withDefault([]),
    registrationType: parseAsArrayOf(
      parseAsStringEnum<RegistrationType>(Object.values(RegistrationType)),
    ).withDefault([]),
    startDate: parseAsIsoDateTime,
    endDate: parseAsIsoDateTime,
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString.withDefault('startedAt'),
  });

  const changeFilterParams = (params: {
    examCenter: string[];
    province: string[];
    startDate: Date | null;
    endDate: Date | null;
    registrationType: RegistrationType[];
    examType: ExamType[];
  }) => {
    setQueryParams({ ...params, page: 0 });
  };

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setQueryParams({ sortOrder, page: 0, sortBy });
  };

  return [
    {
      examCenter,
      province,
      startDate,
      endDate,
      registrationType,
      examType,
      sortBy,
      sortOrder,
      page,
      pageSize,
    },
    { changeFilterParams, changePageNumber, changePageSize, changeSorting },
  ] as const;
}
